import { useState } from "react";

export default function Simple({
  placeholder = "",
  type,
  id,
  formValue,
  formOnChange,
  emailBlur,
  setEmailBlur,
  emailValid,
}) {
  return (
    <div
      style={emailBlur && !emailValid ? { border: "1px solid red" } : null}
      className="w-full border border-zi-border-light dark:border-zi-border-dark rounded-lg flex items-center overflow-auto hocus-within:border-zi-border-dark hocus-within:dark:border-zi-border-light"
    >
      <input
        type={type}
        id={id}
        placeholder={placeholder}
        className="text-base w-full p-2 outline-none bg-zi-bg2-light dark:bg-zi-bg2-dark hocus:bg-zi-bg1-light hocus:dark:bg-zi-bg1-dark text-zi-text-light dark:text-zi-text-dark [direction:ltr] text-end"
        value={formValue}
        onClick={() => {
          if (!setEmailBlur) return;
          setEmailBlur(false);
        }}
        onBlur={() => {
          if (!setEmailBlur) return;
          setEmailBlur(true);
        }}
        onChange={formOnChange}
      ></input>
    </div>
  );
}
